import { literal, nullable, number, object, string , type} from "superstruct";

import { INSTAGRAM_POST_TAG_PRODUCT_TYPE } from "../constants";

const InstagramPostProductTagSchema = object({
    id: number(),
    mediaId: nullable(number()),
    variantId: number(),
    coordinateX: number(),
    coordinateY: number(),
    type: literal(INSTAGRAM_POST_TAG_PRODUCT_TYPE),
    product: type({
        id: number(),
        title: string(),
        url: string(),
        thumbnail: string(),
        variant: object({
            id: number(),
            productId: number(),
            title: string(),
            price: string(),
            comparePrice: nullable(string()),
            imageUrl: nullable(string()),
        }),
    }),
});

export default InstagramPostProductTagSchema;
